import { StaticBaseDao } from '@/dao';
import { SeriesSelectLine, SearchRequest, TypeAheadResponse, DuplicateResultLine, PostResponse } from '@/objects/generated';

export class SeriesDao extends StaticBaseDao {
    public static async SeriesAsSelectLine(seriesId: number): Promise<SeriesSelectLine | null> {
        return this.BaseFetch(
            SeriesSelectLine,
            `Series/SeriesAsSelectLine` + '?' + (seriesId == undefined ? '' : `seriesId=${seriesId}`),
            'GET',
        );
    }
    public static async TypeaheadSearch(request: SearchRequest): Promise<TypeAheadResponse | null> {
        return this.BaseFetch(TypeAheadResponse, `Series/TypeaheadSearch`, 'POST', request);
    }
    public static async GetDuplicates(SeriesUID: number, Threshold: number, GroupByYear: boolean): Promise<DuplicateResultLine[]> {
        return this.BaseFetchArray(
            DuplicateResultLine,
            `Series/GetDuplicates` +
                '?' +
                (SeriesUID == undefined ? '' : `SeriesUID=${SeriesUID}`) +
                '&' +
                (Threshold == undefined ? '' : `Threshold=${Threshold}`) +
                '&' +
                (GroupByYear == undefined ? '' : `GroupByYear=${GroupByYear}`),
            'POST',
        );
    }
    public static async Accumulate(SeriesID: number): Promise<PostResponse | null> {
        return this.BaseFetch(PostResponse, `Series/Accumulate` + '?' + (SeriesID == undefined ? '' : `SeriesID=${SeriesID}`), 'POST');
    }
}
